import React from 'react';
import './Checkbox.css';

const Checkbox = ({ checked, onChange, label, className = '', ...props }) => {
  return (
    <label className={`checkbox-container ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="checkbox-input"
        {...props}
      />
      <span className="checkbox-custom">
        {checked && <i className="fas fa-check"></i>}
      </span>
      {label && <span className="checkbox-label">{label}</span>}
    </label>
  );
};

export default Checkbox; 